import { useState, useEffect } from 'react';

const MOBILE_BREAKPOINT = 768; // pixels

function useIsMobile() {
  const [isMobile, setIsMobile] = useState(
    window.innerWidth <= MOBILE_BREAKPOINT
  );

  useEffect(() => {
    const checkDevice = () => {
      setIsMobile(window.innerWidth <= MOBILE_BREAKPOINT);
    };

    window.addEventListener('resize', checkDevice);
    checkDevice(); // Initial check

    return () => {
      window.removeEventListener('resize', checkDevice);
    };
  }, []);

  return isMobile;
}

export default useIsMobile; 